var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer",staticStyle:{"margin":"0","background-color":"#E3EAFD","color":"#0F4C96"}},[_c('div',{staticClass:"float-left"},[_c('strong',[_vm._v("Portal BAESSH")])]),_c('div',{staticClass:"float-right d-none d-sm-inline-block"},[_c('b',[_vm._v("Versión")]),_vm._v(" 3.1 ")])])
}]

export { render, staticRenderFns }